import gql from "graphql-tag";

export const MY_NEWS_CREATE_ITEM = gql`
  mutation createMyNewsItem(
    $title: String!
    $description: String!
    $content: String!
    $validFrom: Date
    $validTo: Date
    $priority: String!
    $publish: Boolean!
    $roleFilters: RoleFilterInput!
  ) {
    createMyNewsItem(
      title: $title
      description: $description
      content: $content
      validFrom: $validFrom
      validTo: $validTo
      priority: $priority
      publish: $publish
      roleFilters: $roleFilters
    ) {
      _id
    }
  }
`;
